import React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PageLayout from "./PageLayout";

const maroon = "#500000";

const FocusedFlowPage = ({
  title,
  subtitle,
  onClose,
  children,
  actions,
  headerActions,
  alert,
  maxWidth = 720,
  hideHeader = false,
}) => {
  return (
    <PageLayout>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth,
          mx: "auto",
          py: 1,
        }}
      >
        {onClose && (
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              color: "#666",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        )}

        {headerActions && (
          <Box sx={{ display: "flex", justifyContent: "flex-start", width: "100%", mb: 3, pl: onClose ? 2 : 0 }}>
            {headerActions}
          </Box>
        )}

        {!hideHeader && (title || subtitle) && (
          <Box sx={{ textAlign: "center", px: onClose ? 6 : 0, mb: 4, mt: 2 }}>
            {title && (
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: maroon,
                  mb: subtitle ? 1.5 : 0,
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body1"
                sx={{
                  color: "#333",
                  maxWidth: 640,
                  mx: "auto",
                  textAlign: "left",
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}

        {alert && <Box sx={{ mb: 3 }}>{alert}</Box>}

        <Box>{children}</Box>

        {actions && (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 4 }}
          >
            {actions}
          </Stack>
        )}
      </Box>
    </PageLayout>
  );
};

export default FocusedFlowPage;
